import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import autobind from 'autobind-decorator'
import { logout } from 'meteor-apollo-accounts'
import { withApollo } from 'react-apollo'

@withGraphQL(gql`
  query me {
    me {
      _id
      emails {
        address
        verified
      }
    }
  }
`)
@withMutation(gql`
  mutation resendVerificationEmail($email: String) {
    resendVerificationEmail(email: $email) {
      success
    }
  }
`)
@withMessage
@withApollo
export default class NoVerified extends React.Component {
  static propTypes = {
    client: PropTypes.object,
    showMessage: PropTypes.func,
    resendVerificationEmail: PropTypes.func,
    me: PropTypes.func
  }

  state = {}

  @autobind
  async logout() {
    await logout(this.props.client)
  }

  async sendEmail() {
    this.setState({ loading: true, errorMessages: null })
    console.log("Enviada conversion a analitycs");
    
    try {
      await this.props.resendVerificationEmail({
        email: this.props.me.emails[0].address
      })
      this.props.showMessage('Email de confirmación enviado a tu correo.')
    } catch (error) {
      this.props.showMessage(error.message, { level: 'error' })
    }
    
    this.setState({ loading: false })
  }

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.paperContainer}>
          <div className={styles.logo}>
            <img src="/email.png" alt="email" />
          </div>
          <h2 className={styles.title}>
            Hola, ¡Estás a un paso de crear tu cuenta!
          </h2>
          <div className={styles.content}>
            Acabas de crear tu cuenta en tufirma.digital. Para poder empezar a
            utilizarla sólo debes activarla.
          </div>
          <div className={styles.content}>
            Se ha enviado a tu correo un email con el link de verificación. Si
            no funciona, solicita otro haciendo click en el siguiente botón:
          </div>
          <div className={styles.button}>
            <Button
              primary
              onClick={() => this.sendEmail()}
              loading={this.state.loading}
            >
              volver a enviar email
            </Button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Layout/NoVerified/index.js